import styles from './ShopV3SaasSidebarSkeleton.module.scss';

const ITEMS = ['s-1', 's-2', 's-3', 's-4', 's-5', 's-6', 's-7', 's-8'];

/**
 * Loading skeleton for the ShopV3Saas sidebar: a column of category rows,
 * each with a square image placeholder and a title line.
 */
export const ShopV3SaasSidebarSkeleton = () => {
  return (
    <div className={styles.container}>
      {ITEMS.map((key) => (
        <div key={key} className={styles.item}>
          <div className={styles.image} />
          <div className={styles.title} />
        </div>
      ))}
    </div>
  );
};
